<template>
  <div>
    <div class="bg-white shadow-lg rounded-lg">    
      <div class="p-10">
        <div class="pb-2 mb-4 border-b border-gray-200">
          <h2 class="text-gray-800 text-2xl font-medium">Show Stock Opname</h2>
        </div>
        <div class="md:flex gap-10">
          <div class="md:flex-col w-full md:w-2/5">
            <div class="md:flex gap-4">
              <div class="flex md:w-2/5">
                <div class="w-full md:mb-2">
                  <label for="record_no" class="label-control md:py-3">Stock Opname No <span class="text-red-600">*</span></label>
                </div>
              </div>
              <div class="flex md:w-3/5">
                <div class="w-full mb-2">
                  <div class="relative flex-1">
                    <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm badge" :class="status === 1 ? 'badge--light-primary' : (status === 2 ? 'badge--success' : 'badge--danger')">{{ statusText }}</span>
                    <input id="record_no" type="text" v-model="recordNumber" class="form-control" readonly>
                  </div>
                </div>
              </div>
            </div>
            <div class="md:flex gap-4">
              <div class="flex md:w-2/5">
                <div class="w-full md:mb-2">
                  <label for="location" class="label-control md:py-3">Location <span class="text-red-600">*</span></label>
                </div>
              </div>
              <div class="flex md:w-3/5">
                <div class="w-full mb-2">
                  <MultiSelect id="location" v-model="stockOpnameLocation" :options="stockOpnameLocations" :value="stockOpnameLocation" :searchable="true" track-by="id" label="name" placeholder="Type to Search" :showLabels="false" :disabled="true">
                    <template slot="caret">
                      <div>
                        <div class="multiselect__select">
                          <span>
                            <svg class="text-gray-500 mt-2 ml-2 w-5 h-5 fill-current" viewBox="0 0 24 24">
                              <path d="M16.59 8.29504L12 12.875L7.41 8.29504L6 9.70504L12 15.705L18 9.70504L16.59 8.29504Z"/>
                            </svg>
                          </span>
                        </div>
                      </div>
                    </template>
                  </MultiSelect>
                </div>
              </div>
            </div>
            <div class="md:flex gap-4">
              <div class="flex md:w-2/5">
                <div class="w-full md:mb-2">
                  <label for="receive_date" class="label-control md:py-3">Stock Opname Date <span class="text-red-600">*</span></label>
                </div>
              </div>
              <div class="flex md:w-3/5">
                <div class="w-full mb-2">
                  <v-date-picker v-model="stockOpnameDate" mode="date" :masks="masks" color="purple" title-position="left" :popover="{ visibility: 'click' }" :attributes="attrs">
                    <template v-slot="{ inputValue, inputEvents }">
                      <div class="md:flex gap-6">
                        <div class="w-full">
                          <div class="relative flex justify-between items-center">
                            <input id="stock_opname_date" type="text" class="form-control" :value="inputValue" v-on="inputEvents">
                            <span class="h-full absolute pointer-events-none right-0">
                              <DateRange class="m-3" />
                            </span>                      
                          </div>
                        </div>
                      </div>
                    </template>
                  </v-date-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="md:flex-col w-full md:w-3/5">
            <div class="md:flex gap-4">
              <div class="flex md:w-2/6">
                <div class="w-full md:mb-2">
                  <label for="stock_opname_season" class="label-control md:py-3">Stock Opname Season <span class="text-red-600">*</span></label>
                </div>
              </div>
              <div class="w-full md:w-4/6 gap-2">
                <MultiSelect id="stock_opname_season" v-model="stockOpnameSeason" :options="seasons" :value="stockOpnameSeason" :searchable="true" track-by="id" label="name" placeholder="Type to Search" :disabled="true">
                  <template slot="caret">
                    <div>
                      <div class="multiselect__select">
                        <span>
                          <svg class="text-gray-500 mt-2 ml-2 w-5 h-5 fill-current" viewBox="0 0 24 24">
                            <path d="M16.59 8.29504L12 12.875L7.41 8.29504L6 9.70504L12 15.705L18 9.70504L16.59 8.29504Z"/>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </template>
                </MultiSelect>
              </div>
            </div>
            <div class="md:flex gap-4">
              <div class="flex md:w-2/6">
                <div class="w-full md:mb-2">
                  <label for="stock_opname_for_season" class="label-control md:py-3">Stock Opname For Season <span class="text-red-600">*</span></label>
                </div>
              </div>
              <div class="w-full md:w-4/6 gap-2">
                <MultiSelect id="stock_opname_for_season" v-model="stockOpnameForSeason" :options="seasons" :value="stockOpnameForSeason" :searchable="true" track-by="id" label="name" placeholder="Type to Search" :disabled="true">
                  <template slot="caret">
                    <div>
                      <div class="multiselect__select">
                        <span>
                          <svg class="text-gray-500 mt-2 ml-2 w-5 h-5 fill-current" viewBox="0 0 24 24">
                            <path d="M16.59 8.29504L12 12.875L7.41 8.29504L6 9.70504L12 15.705L18 9.70504L16.59 8.29504Z"/>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </template>
                </MultiSelect>
              </div>
            </div>          
          </div>
        </div>
        <!-- CALL STOCK OPNAME DETAILS -->
        <TransactionDetail class="mb-10" />

        <!-- SUMMARY DATA SECTION -->
        <div class="md:flex gap-6">
          <div class="md:w-1/2 mb-4">
            <label for="remarks" class="label-control">Remarks</label>
            <textarea id="remarks" v-model="remarks" class="form-control" rows="3"></textarea>
          </div>
          <div class="md:w-1/2 mb-4">
          </div>
        </div>
        <div class="flex gap-4 md:justify-between items-center mt-10 mb-2">
          <button :disabled="isLoading" type="button" @click="goBack()" class="btn btn--secondary" alt="Back" title="Back">
            <BackIcon>
              <span class="ml-2 md:block hidden">Back</span>
            </BackIcon>
          </button>
        </div>
      </div>
    </div>   
  </div>
</template>

<script>
import format from '@/helpers/formatNumber'
import factoryServices from '@/services/factory/factoryServices'
import seasonServices from '@/services/season/seasonServices'
import opnameServices from '@/services/stockOpname/opnameServices'
import BackIcon from '../../icons/BackIcon'
import DateRange from '../../icons/DateRange'
import TransactionDetail from './Detail'

export default {
  name: 'EditStockOpname',
  components: {
    BackIcon,
    DateRange,
    TransactionDetail,
  },  
  data(){
    return {
      recordNumber: '',
      stockOpnameLocation: '',
      stockOpnameLocations: [],
      stockOpnameSeason: '',
      stockOpnameForSeason: '',
      seasons: [],
      stockOpnameDate: new Date(),
      masks: {
        input: 'YYYY-MM-DD',
      },
      attrs: [
        {
          key: 'today',
          highlight: 'red',
          dates: new Date(),
        },
      ],      
      remarks: '',
      status: '',
      statusText: '',
      record: [],
      details: [],
      error: [],
      showFunction: false,
      isLoading: false,
      activeTab: '1',
      toastedOptions: {
        position: "top-right", 
        duration : 5000,
        action: {
          text: 'x',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          }
        }  
      }      
    }
  },
  methods: {
    async fetchData(){
      try {
        const id = this.$route.params.id
        const response = await opnameServices.fetchById(id)
        if (response.data.status === 'success') {
          this.record = response.data.data

          this.recordNumber = this.record.record_no
          this.stockOpnameLocation = { 'id': this.record.factory_id, 'name': this.record.factory.factory_name, 'code': this.record.factory.factory_code }
          this.stockOpnameDate = this.record.stock_opname_date
          this.stockOpnameSeason = { 'id': this.record.so_season_id, 'name': this.record.stock_opname_season.season_name }
          this.stockOpnameForSeason = { 'id': this.record.so_for_season_id, 'name': this.record.stock_opname_for_season.season_name }
          this.remarks = this.record.remarks
          this.status = this.record.status
          this.statusText = this.record.status_text      
        } else {
          /* THROW ERROR MESSAGES */
          this.$toasted.error(response.data.message, this.toastedOptions)            
        }
      } catch (error) {
        console.log(error)
      }
    },   
    async fetchFactory() {
      try {
        const response = await factoryServices.fetchDataOptions(null)
        if (response.data.status === 'success') {
          const records = response.data.data
          this.stockOpnameLocations = []
          records.forEach(element => {
            this.stockOpnameLocations.push({
              'id': element.id,
              'name': element.factory_name,
              'code': element.factory_code
            })
          })
        } else {
          /* THROW ERROR MESSAGES */
          this.$toasted.error(response.data.message, this.toastedOptions)          
        }        
      } catch (error) {
        console.log(error)
      }
    },
    async fetchSeasonData() {
      try {
        const response = await seasonServices.fetchDataOptions(null)
        if (response.data.status === 'success') {
          const records = response.data.data
          this.seasons = []
          records.forEach(element => {
            this.seasons.push({
              'id': element.id,
              'name': element.season_name
            })
          });          
        } else {
          /* THROW ERROR MESSAGES */
          this.$toasted.error(response.data.message, this.toastedOptions)          
        }
      } catch (error) {
        console.log(error)
      }
    },
    nameWithAddress ({ name, address }) {
      if (address) {
        return `${name} [ ${address} ]`
      }
      return `${name}`
    },    
    formatNumber(num) {
      let result = format.formatNumber(num)
      return result
    },
    unformatNumber(num) {
      let result = format.unformatNumber(num)
      return result
    },
    toFixed(num, digit) {
      let result = format.toFixed(num, digit)
      return result
    },
    goBack() {
      window.history.length > 1 ? this.$router.back() : this.$router.push('/stock-opname')
    }      
  },
  created(){
    this.fetchFactory()
    this.fetchSeasonData()
    this.fetchData()
  }
}
</script>